import React from "react";

const DateBox = ({ date, month, year, selected, hasPlan, OnSelect }) => {
  return (
    <div
      className={`min-w-[5.5rem] sm:min-w-[6rem] md:min-w-[7rem] py-4 px-2 mr-4 flex flex-col items-center justify-center rounded-md cursor-pointer relative ${
        selected ? "bg-dark-orange" : "bg-light-orange"
      } ${hasPlan && !selected ? "ring-2 ring-orange-300 ring-offset-1" : ""}`}
      onClick={OnSelect}
    >
      {hasPlan && !selected && (
        <span
          className="absolute top-1.5 right-1.5 w-1.5 h-1.5 rounded-full bg-orange-500"
          aria-hidden
        />
      )}
      <div className="flex flex-col items-center text-center whitespace-nowrap">
        <div className="text-sm sm:text-base font-semibold">{date}</div>
        <div className="text-xs sm:text-sm">{month}</div>
        <div className="text-xs sm:text-sm hidden sm:block">{year}</div>
      </div>
    </div>
  );
};

export default DateBox;
